


<section>
<div class="wrapper">
<article class="mrt-75" style="background-color: #F5F5F5;">
  <div class="container ml-5">
  <h2 class="header-name"><mat-icon class="custom-icon-button users people-icon">people</mat-icon>
   <span><a class="tag" routerLink="/cp/user-management">Users List</a></span><mat-icon class="chevron arrow-icon">chevron_right</mat-icon>
   <span>{{headerName}}</span></h2>
  </div>
 <div class="container-fluid"  style="height: 120vh !important;">
  <form [formGroup]="userForm" autocomplete="off">
   
      <div  class="row"> 
        <div class="col-md-6">
          <div class="form-bgd">
              <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="form-feild" >
                      <mat-label class="asterix--before">Name </mat-label>
                      <input style="background-color: #fff;" matInput type="text" class="form-controll" name="name" formControlName="name" />
                      <mat-error *ngIf="userForm?.controls['name'].touched && userForm?.controls['name'].hasError('required')">
                        {{errorMessageFormField.name}}
                      </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">    
                    <mat-form-field appearance="outline" class="form-feild">
                      <mat-label class="asterix--before">User Name</mat-label>
                      <input matInput type="text" class="form-controll" name="userName" formControlName="userName" [readonly]="isEditable" autocomplete="off"/>
                      <mat-error *ngIf="userForm?.controls['userName'].touched && userForm?.controls['userName'].hasError('required')">
                        {{errorMessageFormField.userName}}
                      </mat-error>
                    </mat-form-field>
                </div>
              </div>  

              <div class="row">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild">
                    <mat-label class="asterix--before">User Type</mat-label>
                    <mat-select formControlName="userType" required>
                      <mat-option *ngFor="let type of userTypes" [value]="type">
                        {{ type }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="userForm?.controls['userType'].touched && userForm?.controls['userType'].hasError('required')">
                      User Type is required
                    </mat-error>
                  </mat-form-field> 
                </div>  
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild">
                    <mat-label class="asterix--before">Email ID</mat-label>
                    <input matInput type="text" class="form-controll" name="emailId" formControlName="emailId" />
                    <mat-error *ngIf="userForm?.controls['emailId'].touched && userForm?.controls['emailId'].hasError('required')">
                      {{errorMessageFormField.emailId}}
                    </mat-error>
                  </mat-form-field>
                </div>  
              </div>

              <div class="row">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild" *ngIf="canShowPassword">
                    <mat-label class="asterix--before">Password </mat-label>
                    <input matInput [type]="showPassword ? 'text' : 'password'" class="form-controll" name="password" formControlName="password" autocomplete="new-password"/>
                    <button mat-icon-button matSuffix (click)="toggleShowPassword()">
                      <mat-icon>{{!showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <!-- Decrypt password icon for Super Admin -->
                    <button *ngIf="canDec && isEditable && userForm.get('password')?.value" 
                            mat-icon-button matSuffix 
                            (click)="revealValue()"
                            [disabled]="isDecr"
                            style="margin-right: 8px;">
                      <mat-icon>{{ isDecr ? 'hourglass_empty' : 'lock_open' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="userForm?.controls['password'].touched && userForm?.controls['password'].hasError('required')">
                      {{errorMessageFormField.user_password}}
                    </mat-error>
                    <mat-error *ngIf="userForm?.controls['password'].touched && userForm?.controls['password'].hasError('passwordStrength')">
                      {{errorMessageFormField.passwordStrength}}
                    </mat-error>
                  </mat-form-field>
                  
                  <div *ngIf="canDec && decryptedPassword" class="decrypted-password-container" style="margin-top: 8px;">
                    <mat-form-field appearance="outline" class="form-feild" style="width: 100%;">
                      <mat-label>Decrypted Password</mat-label>
                      <input matInput [value]="decryptedPassword" readonly class="form-controll" style="background-color: #f5f5f5;"/>
                      <button mat-icon-button matSuffix (click)="clearDecryptedPassword()" matTooltip="Clear">
                        <mat-icon>clear</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6"> 
                  <mat-form-field *ngIf="!hideConfirmPassword" appearance="outline" class="form-feild">
                    <mat-label class="asterix--before">Confirm Password </mat-label>
                    <input matInput [type]="showConfirmPassword ? 'text' : 'password'" class="form-controll" name="confirmpassword" formControlName="confirmpassword" autocomplete="new-password"/>
                    <button mat-icon-button matSuffix (click)="toggleConfirmPassword()">
                      <mat-icon>{{!showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="userForm?.controls['confirmpassword'].touched && userForm?.controls['confirmpassword'].hasError('required')">
                      {{errorMessageFormField.confirmpassword}}
                    </mat-error>
                    <mat-error *ngIf="userForm?.controls['confirmpassword'].touched && userForm?.controls['confirmpassword'].hasError('passwordStrength')">
                      {{errorMessageFormField.passwordStrength}}
                    </mat-error>
                    <mat-error *ngIf="userForm.get('confirmpassword').errors?.passwordMismatch">
                      {{errorMessageFormField.passwordMatch}}
                    </mat-error>
                  </mat-form-field>
                </div>     

                <div *ngIf="isEditable" class="col-md-12 user-verified-row">
                  <mat-checkbox class="active-checkbox user-verified-checkbox" name="contactVerified"
                    formControlName="contactVerified">User Verified</mat-checkbox>
                </div>
                <div *ngIf="isEditable" class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild">
                    <mat-label>Created By </mat-label>
                    <input matInput type ='text' class="form-controll" name="createdBy" formControlName="createdBy" [readonly]="isEditable"/>
                  </mat-form-field>
                </div>
                <div *ngIf="isEditable" class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild">
                    <mat-label>Created At </mat-label>
                    <input matInput type ='text' class="form-controll" name="createdAt" formControlName="createdAt" [readonly]="isEditable"/>
                  </mat-form-field>
                </div>
             </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="phone-fields-group">
                    <mat-form-field appearance="outline" floatLabel="always" class="country-code-form-field">
                      <mat-label>Code</mat-label>
                      <mat-select formControlName="countryCode" class="country-code-dropdown">
                        <mat-option *ngFor="let country of countries" [value]="country.dialCode">
                          {{ country.dialCode }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" class="phone-number-form-field">
                      <mat-label>Phone Number</mat-label>
                      <input matInput type="tel" formControlName="phoneNo" placeholder="Enter phone number" class="phone-input" style="background-color: #fff;"/>
                      <mat-error *ngIf="userForm.get('phoneNo')?.hasError('nonNumericPhone')">
                       Only numbers are allowed.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>  
                <div class="col-md-6">
                  <mat-form-field  *ngIf="!hideUserRole" appearance="outline" class="form-feild">
                    <mat-label>User Role</mat-label>
                    <mat-select formControlName="userRole">
                      <mat-option *ngFor="let role of userRoles" [value]="role">
                        {{ role }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                    <div *ngIf="isEditable" class="col-md-6">
                  <mat-form-field appearance="outline" class="form-feild">
                    <mat-label>Source </mat-label>
                    <input matInput type ='text' class="form-controll" name="userSource" formControlName="userSource" [readonly]="isEditable"/>
                  </mat-form-field>
                </div>
              </div>
              <div class="flexBox align-center mfa-row">
          <div class="checkbox-active">
            <mat-checkbox class="active-checkbox mfa-checkbox" name="mfaActive"
                formControlName="mfaActive">MFA Active</mat-checkbox>
           </div>
            <div class="add-sites" *ngIf="userForm.get('userType').value === 'Customer'  || userForm.get('userType').value === 'Sales Rep'">
              <button type="button" class="add-site-button add-btn" mat-raised-button (click)="openSiteSelectionDialog()" style="min-width: 100px;margin-left: 10px;">
                <mat-icon class="add-icon">add</mat-icon>
                <span>Add Sites</span>
              </button>
            </div>
    
             </div>
             <div class="action-buttons text-center" style="margin-top: 10px;">
          <button mat-stroked-button color="basic" class="back" type="submit" routerLink="/cp/user-management">
            Cancel
          </button>
          <button mat-raised-button class="save-btn" type="submit" *ngIf="isEditable" (click)="updateForm()">
            Update
          </button>
          <button mat-raised-button class="save-btn" type="submit" *ngIf="!isEditable" (click)="addForm()">
            Save
          </button>
            </div>
          </div>
        </div>

     <div class="col-md-6">
  <div class="selected-sites-panel">
    <div class="selected-sites-header um-toolbar">
      <h2 class="header-site">Selected Sites</h2>
      <mat-form-field *ngIf="userForm.get('userType')?.value !== 'Customer' && userForm.get('userType')?.value !== 'Sales Rep' && userForm.get('userType')?.value !== ''"
        appearance="fill"
        floatLabel="always"
        class="form-field search-field">
        <mat-label>Search</mat-label>
        <input matInput [formControl]="searchTerm" (keydown.enter)="onSearchEnter($event)">
        <button type="button" mat-icon-button matSuffix class="suffix-icon-btn" (click)="filterSelectedSites()">
          <mat-icon>search</mat-icon>
        </button>
        <button type="button" mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!searchTerm.value" (click)="clearSelectedSiteSearch()">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="table-responsive selected-sites-table">
      <div class="um-table-wrap table-paginator-container">
      <table mat-table [dataSource]="selectedSitesDataSource" class="mat-table um-table um-table-sites selected-site-table">
        <ng-container matColumnDef="siteName">
          <th class="left-sorted-header col-site-name" mat-header-cell *matHeaderCellDef>Site Name</th>
          <td class="left-sorted-header col-site-name" mat-cell *matCellDef="let element">{{element.siteName}}</td>
        </ng-container>

        <ng-container matColumnDef="accountName">
          <th class="centered-sorted-header col-account" mat-header-cell *matHeaderCellDef>Account Name</th>
          <td class="centered-sorted-header col-account" mat-cell *matCellDef="let element">{{element.accountName}}</td>
        </ng-container>

        <ng-container matColumnDef="potentialId">
          <th class="centered-sorted-header col-id" mat-header-cell *matHeaderCellDef>Potential ID</th>
          <td class="centered-sorted-header col-id" mat-cell *matCellDef="let element">{{element.potentialId}}</td>
        </ng-container>

        <ng-container matColumnDef="analyticId">
          <th class="centered-sorted-header col-id" mat-header-cell *matHeaderCellDef>AID</th>
          <td class="centered-sorted-header col-id" mat-cell *matCellDef="let element">{{element?.analyticId}}</td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th class="centered-sorted-header col-status" mat-header-cell *matHeaderCellDef>Stage</th>
          <td class="centered-sorted-header col-status" mat-cell *matCellDef="let element">{{element?.stage}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th class="centered-sorted-header col-status" mat-header-cell *matHeaderCellDef>Status</th>
          <td class="centered-sorted-header col-status" mat-cell *matCellDef="let element">{{element?.status}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th class="centered-sorted-header col-narrow" mat-header-cell *matHeaderCellDef>Action</th>
          <td class="centered-sorted-header col-narrow" mat-cell *matCellDef="let element">
            <button mat-icon-button color="warn" (click)="removeSelectedSite(element)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedSelectedSitesColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedSelectedSitesColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="text-center no-sites-cell" [attr.colspan]="displayedSelectedSitesColumns.length">
            No sites assigned.
          </td>
        </tr>
      </table>
    </div>
  <mat-paginator class="compact-paginator"
    *ngIf="userForm.get('userType')?.value && userForm.get('userType')?.value !== 'Customer' && userForm.get('userType')?.value !== 'Sales Rep'"
    #sitesPaginator
    [length]="totalSites"
    [pageSize]="sitePageSize"
    [pageSizeOptions]="[5, 25, 50, 100]"
    [pageIndex]="sitePageIndex"
    showFirstLastButtons
    (page)="onSitePageChange($event)">
  </mat-paginator>
  </div>
</div>
</div>
      </div>
  
  </form>
  </div>
  
  
  <!--sites dialog-->
    <ng-template #dialogTemplate class="dialog-temp" style="overflow: hidden;">
      <div class="mat-dialog-device-details dialog">
        <div>
        <form [formGroup]="sitesForm">
          <div class="row" style="display: flex; align-items: center; justify-content: space-between;">
            <div style="flex: 1; text-align: left;">
              <h2 class="title-header">{{header}}</h2>
            </div>
            <div style="flex: 2; display: flex; justify-content: center;">
              <mat-form-field appearance="fill" class="search-field" style="height: 35px;">
                <mat-label>Search</mat-label>
                <input matInput formControlName="searchKeyword">
                <button mat-icon-button matSuffix (click)="filterSites()">
                  <mat-icon>search</mat-icon>
                </button>
                <button mat-icon-button matSuffix *ngIf="sitesForm.controls['searchKeyword'].value" (click)="clearSearch()">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div style="flex: 1; text-align: right;">
              <button mat-icon-button aria-label="close dialog" class="close-dialog" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </form>
        
         
        <ng-container *ngIf="!hideSiteNames">
          <div class="sites-table">
          <table mat-table [dataSource]="dataSource" class="w-100">
            <ng-container matColumnDef="select">
              <th class="site-header" mat-header-cell *matHeaderCellDef style="width: 4%; padding-top: 6px;">
                <div class="main-cb">
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()" >
                  </mat-checkbox>
                </div>
              </th>
              <td mat-cell *matCellDef="let row; let i = index">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="selection.toggle(row);siteSelectedValue($event,row)"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="siteName">
              <th class="site-header" mat-header-cell *matHeaderCellDef> Site Name </th>
              <td class="site-row" mat-cell *matCellDef="let row">{{ row.siteName }}</td>
            </ng-container>
            <ng-container matColumnDef="potentialId">
              <th class="site-header" mat-header-cell *matHeaderCellDef style="width: 10%;"> Potential ID </th>
              <td class="site-row" mat-cell *matCellDef="let row">{{ row.potentialId }}</td>
            </ng-container>
            <ng-container matColumnDef="accountName">
              <th class="site-header" mat-header-cell *matHeaderCellDef> Account Name </th>
              <td class="site-row" mat-cell *matCellDef="let row">{{ row.accountName }}</td>
            </ng-container>
          
            <ng-container matColumnDef="analyticId">
              <th style="width: 20%;" class="site-header text-center" mat-header-cell *matHeaderCellDef> AID </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.analyticId}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
          </table>
        </div>
        </ng-container>
        
        </div>
        <mat-paginator  #paginator [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="[8, 25, 50, 100]"
          [pageIndex]="pageIndex" showFirstLastButtons (page)="onPageChange($event)"></mat-paginator>
          <div class="text-center">
            <button  mat-stroked-button color="basic" class="back" (click)="closeDialog()">Cancel</button>
            <button class="select-btn" mat-raised-button (click)="saveSelected()">Add Site</button>
          </div>
      </div>
    </ng-template>
  </article>
</div>
</section> 


